import queryString from 'query-string';

export function getQueryParams(qs) {
  qs = qs.split('+').join(' ');
  const params = {};
  const re = /[?&]?([^=]+)=([^&]*)/g;
  let tokens;
  while ((tokens = re.exec(qs))) {
    params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
  }
  return params;
}

export function addQueryParams(url, params) {
  const query = queryString.stringify(params, { arrayFormat: 'comma' });
  return `${url}${query ? `?${query}` : ''}`;
}

export function isRouteWithSidebar(pathname) {
  return /\/dossiers\/[a-f\d]{24}\//gim.test(pathname);
}
